import { useEffect } from 'react';
import { useAsyncData } from '../../hooks/useAsyncData';
import { useTRPC } from '../../hooks/useTRPC';

import { captureAndReportError } from '../../utils/errorReporting';
import { SOLANA_CLUSTER, SOLANA_IS_MAINNET } from '../../utils/solanaUtils';

export function NetworkIndicator() {
  const trpc = useTRPC();
  const {
    data: backendNetwork,
    isLoading,
    run,
  } = useAsyncData<string | null>({
    initialData: null,
    initialLoading: true,
  });
  const frontendNetwork = SOLANA_CLUSTER;

  useEffect(() => {
    void run(() => trpc.getSolanaNetwork.query(undefined), {
      onSuccess: (result, helpers) => {
        helpers.setData(result.network);
      },
      onError: (error) => {
        captureAndReportError(error, { component: 'NetworkIndicator' });
      },
    });
  }, [run, trpc.getSolanaNetwork]);

  const networkMismatch = backendNetwork && backendNetwork !== frontendNetwork;
  const shouldShowChip = !(
    frontendNetwork === 'mainnet' && backendNetwork === 'mainnet'
  );

  if (isLoading || !shouldShowChip) {
    return null;
  }

  return (
    <div
      className={`fixed bottom-4 right-4 px-3 py-1 rounded-lg text-xs font-medium shadow-lg ${
        SOLANA_IS_MAINNET ? 'bg-red-600 text-white' : 'bg-blue-600 text-white'
      }`}
      style={{
        zIndex: 50,
        border: '3px solid yellow',
        backgroundColor: '#2563eb',
        color: 'white',
      }}
    >
      <div className="flex items-center gap-2">
        <span
          className={`w-2 h-2 rounded-full ${
            SOLANA_IS_MAINNET ? 'bg-white' : 'bg-green-400'
          } animate-pulse`}
        />
        <span className="uppercase">{frontendNetwork}</span>
        {networkMismatch && (
          <span className="ml-2 text-yellow-300">
            ⚠️ Backend: {backendNetwork}
          </span>
        )}
      </div>
    </div>
  );
}
